var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoricoFaturas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18 0h20.854c1.28 0 2.318 1.037 2.318 2.317v33.986c0 1.28-1.038 2.318-2.318 2.318H2.317C1.037 38.62 0 37.583 0 36.303V6.18L6.18 0",
    transform: "translate(9.8 5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.724 3.09L7.724 7.724 3.09 7.724M33.214 6.18h1.545c1.28 0 2.317 1.037 2.317 2.317v33.986c0 1.28-1.037 2.317-2.317 2.317H10.04c-1.28 0-2.317-1.037-2.317-2.317M6.952 28.579L22.4 28.579M6.952 20.855L22.4 20.855M14.676 13.131L22.4 13.131",
    transform: "translate(9.8 5.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricoFaturas);
export default __webpack_public_path__ + "static/media/historico-faturas.770948e3.svg";
export { ForwardRef as ReactComponent };